import styled from "@emotion/styled";
import { css } from "@/domains/emotion";
import { mdsColors, mdsFontSizes } from "@/design-system/foundations";

export const StyledReasoningMessage = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

export const StyledActionMessage = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes.smedium};
  line-height: ${({ theme }) => theme.lineHeights.smedium};
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  a {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: underline;
  }
`;

export const StyledCommunicationMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes["paragraph-sm"]};
  line-height: ${({ theme }) => theme.lineHeights["paragraph-sm"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

export const actionStepCheckmarkStyle = css({
  color: mdsColors().green.x500,
  width: mdsFontSizes().smedium,
  height: mdsFontSizes().smedium,
});
